import * as actions from './campaignReducer';
import Axios from 'axios';
import { push } from 'react-router-redux';
import queryString from '../../../helpers/queryString';
import handleErrorResponse from '../../../helpers/handleErrorResponse';
import { toastr } from 'react-redux-toastr';
import { ADD_RESOURCE } from '../../layout/redux/breadcrumb';

export const defaultIncludes = ['brokers', 'insurer', 'channels', 'product', 'schemes'];

// + '?include=brokers,channels'
export const getCampaigns = (id, includes = defaultIncludes) => {
  return (dispatch) => {
    const endpoint = `campaigns/${id}/${queryString(includes)}`;

    return Axios.get(endpoint)
      .then((response) => {
        dispatch({
          type: actions.SET_CAMPAIGN,
          data: response.data,
        });
        dispatch({
          type: ADD_RESOURCE,
          id: response.data.data.id,
          name: response.data.data.attributes.code,
        });
        return true;
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

export const getCampaign = (id, includes = defaultIncludes, fields) => {
  return (dispatch) => {
    const endpoint = `campaigns/${id}${queryString(includes)}&${fields}`;

    return Axios.get(endpoint)
      .then((response) => {
        dispatch({
          type: actions.SET_CAMPAIGN,
          data: response.data,
        });
        dispatch({
          type: ADD_RESOURCE,
          id: response.data.data.id,
          name: response.data.data.attributes.code,
        });
        return true;
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

const setUnassignedSchemes = (campaignId, data) => {
  return {
    type: actions.SET_UNASSIGNED_SCHEMES,
    schemes: data,
    campaignId: campaignId,
  };
};

export const getUnassignedSchemes = (campaignId, productId) => {
  return (dispatch) => {
    const endpoint = `campaign/schemes-not-assigned/${campaignId}/${productId}?filter[product]=${productId}`;
    return Axios.get(endpoint).then((res) => {
      dispatch(setUnassignedSchemes(campaignId, res.data.meta));
      return true;
    });
  };
};

export const getAllCampaigns = (includes = defaultIncludes) => {
  return (dispatch) => {
    let endpoint = 'campaigns/';
    endpoint += queryString(includes);

    return Axios.get(endpoint)
      .then((response) => {
        dispatch({
          type: actions.SET_ALL_CAMPAIGNS,
          data: response.data,
        });
        return true;
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

// Receives an array of IDs
export const changeEndDates = (arrayOfIds, newDate) => {
  return (dispatch) => {
    dispatch(isSaving(true));
    dispatch(submitSucceeded(false));
    return Axios.patch('campaigns:update-end-date', {
      meta: { campaigns: arrayOfIds, to_date: newDate },
    })
      .then(() => {
        dispatch(isSaving(false));
        dispatch(submitSucceeded(true));
        toastr.success('Success', 'End date updated');
        return true;
      })
      .catch((error) => {
        dispatch(isSaving(false));
        dispatch(submitSucceeded(false));
        handleErrorResponse(error, 'Failed');
      });
  };
};

export const updateCampaign = (resource, includes = defaultIncludes) => {
  return (dispatch) => {
    //dispatch(isSubmitting(true))
    const id = resource.data.id;
    let endpoint = 'campaigns/' + id;
    endpoint += queryString(includes);

    return Axios.patch(endpoint, resource)
      .then((response) => {
        dispatch({
          type: actions.SET_CAMPAIGN,
          data: response.data,
        });
        //dispatch(isSubmitting(false))
        dispatch(push('/admin/campaigns/' + response.data.data.id));
        return true;
      })
      .catch((error) => {
        //dispatch(isSubmitting(false))
        handleErrorResponse(error, 'There was an error updating the campaign');
      });
  };
};

export const endCampaign = (campaignId) => {
  return (dispatch) => {
    const endpoint = 'campaigns/' + campaignId + ':end';

    return Axios.post(endpoint)
      .then(() => {
        toastr.success('Success', 'End date updated');
        dispatch(push('admin/campaigns/'));
      })
      .catch((error) => {
        handleErrorResponse(error, 'There was an error ending the campaign');
      });
  };
};

export const isSaving = (status) => {
  return {
    type: actions.IS_SAVING,
    status,
  };
};

export const isRetrieving = (status) => {
  return {
    type: actions.IS_SAVING,
    status,
  };
};

export const submitSucceeded = (status) => {
  return {
    type: actions.SUBMIT_SUCCEEDED,
    status,
  };
};

export const createCampaign = (resource) => {
  return (dispatch) => {
    dispatch(isSaving(true));
    return Axios.post('campaigns', resource)
      .then((response) => {
        dispatch(isSaving(false));
        dispatch(push('/admin/campaigns/' + response.data.data.id));
        return true;
      })
      .catch((error) => {
        dispatch(isSaving(false));
        handleErrorResponse(error, 'There was an error creating the campaign');
      });
  };
};

export const updateCampaignBannerMetadata = (resource, includes = defaultIncludes) => {
  return (dispatch) => {
    const id = resource.data.id;
    let endpoint = 'banners/update/' + id;
    endpoint += queryString(includes);
    return Axios.patch(endpoint, resource)
      .then((response) => {
        dispatch(push('/admin/campaigns/' + response.data.data.id));
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'There was an error updating the campaign');
      });
  };
};

export const addSchemesToCampaign = (campaignId, payload, includes = defaultIncludes) => {
  return (dispatch) => {
    dispatch(isSaving(true));
    dispatch(submitSucceeded(false));
    let endpoint = `campaigns/${campaignId}:add-schemes`;
    endpoint += queryString(includes);
    return Axios.post(endpoint, payload)
      .then(() => {
        dispatch(isSaving(false));
        dispatch(submitSucceeded(true));
        toastr.success('Success', 'Schemes Assigned');
        return true;
      })
      .catch((error) => {
        dispatch(isSaving(false));
        dispatch(submitSucceeded(false));
        handleErrorResponse(error, 'There was an error updating the campaign');
      });
  };
};
